import React from 'react'
import Logo from '../images/logo.svg'
import { Link } from 'react-router-dom'
import { useLanguage } from '../context/LanguageContext'
import { translations } from '../translations/translations'

const Navbar = () => {
  const { language, changeLanguage } = useLanguage();
  const t = translations[language];

  return (
    <div className="container">
    <div className='nav-bar-main'>
      
      <div className="left">
        <div className="logo">
          <img src={Logo} alt="Avopla Logo" />
        </div>
        <div className="links">
          <Link className="link" to='/'>{t.nav.whyAvopla}</Link>
          <Link className="link" to='/plans'>{t.nav.pricing}</Link>
        </div>
      </div>
      <div className="right-section">
        <Link className="button" to='https://www.manager.avopla.ca/' target='_blank' rel="noopener noreferrer">{t.nav.login}</Link>
      </div>
      
      </div>
      </div>
  )
}

export default Navbar